<template>
  <div>
    <div class="row">
      <div class="col-6">
        <div>
          <label class="me-3" for="color">cpu colors</label>
          <el-color-picker color-format="rgb" v-model="cpuColors[0]" />
        </div>
        <div>
          <label class="me-3" for="color">gpu colors</label>
          <el-color-picker color-format="rgb" v-model="gpuColors[0]" />
        </div>
        <div>
          <label class="me-3" for="color">ram colors</label>
          <el-color-picker color-format="rgb" v-model="ramColors[0]" />
        </div>
        <div>
          <label class="me-3" for="color">time colors</label>
          <el-color-picker color-format="rgb" v-model="timeColors[0]" />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <button type="button" class="btn btn-primary mx-2" @click.stop="handleSubmit">確認</button>
        <button type="button" class="btn btn-secondary mx-2" @click.stop="handleInit">清空</button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive } from 'vue'
import ColorTool from "@/utils/colorTool";

const {getRgbFilterString} = ColorTool()

const emit = defineEmits(['getTempControlData'])
const props = defineProps(['effectName'])
const tempControlData = reactive({
  Theme: {}
})

const cpuColors = ref(['rgb(23, 190, 255)'])
const gpuColors = ref(['rgb(0, 255, 88)'])
const ramColors = ref(['rgb(248, 215, 0)'])
const timeColors = ref(['rgb(255, 255, 255)'])

function handleSubmit () {
  Object.assign(tempControlData.Theme, {
    Effect: props.effectName,
    CpuColors: cpuColors.value.map(c => getRgbFilterString(c)),
    GpuColors: gpuColors.value.map(c => getRgbFilterString(c)),
    RamColors: ramColors.value.map(c => getRgbFilterString(c)),
    TimeColors: timeColors.value.map(c => getRgbFilterString(c)),
  })

  emit('getTempControlData', tempControlData)

}

function handleInit () {
  cpuColors.value = ['rgb(23, 190, 255)']
  gpuColors.value = ['rgb(0, 255, 88)']
  ramColors.value = ['rgb(248, 215, 0)']
  timeColors.value = ['rgb(255, 255, 255)']
  handleSubmit()
}

</script>
